<div class="page">
    <app-step-progress [steps]="steps"></app-step-progress>
    <app-page-title [title]="'SCORE REPORTS'"></app-page-title>

    <div *ngIf="storeTestScoresOption && testTypeId">
        <div class="bg-policy">
            <p>
                <span *ngIf="brandName === 'CAEL'">
                Your CAEL scores will be available in your CAEL Account 8 business days after the test date. Your CAEL Official Score Report will be available for download as a PDF
                once your scores have been posted. You can submit your PDF Official Score Report to an academic institution or professional organization.
                <br /><br />
               </span>
                Please select your score recipients below. By selecting a score recipient, you give the institution access to your scores for verification purposes.
            </p>
        </div>
        <app-score-report-options-selector
            [testTypeId]="testTypeId"
            [isWebDelivery]="isWebDelivery"
            [regInProgress]="true"
            [storeTestScoresOption]="storeTestScoresOption"
            [showIRCCOnNewInstitutions]="showIrccOnNewInstitutions"
        ></app-score-report-options-selector>
    </div>

</div>

<div *ngIf="this.continueClicked">
    <div>
        <div
            *ngIf="brandName === 'CELPIP'"
            style="font-weight: 500;"
        >Your
            <span>Official</span>
            {{brandName}} Score Report will be available in your {{brandName}} Account for download as a PDF once your scores have been posted.
        </div>
        <div class="note my-3">Note: Test scores SMS are for informative purposes only. You will need to submit the Official {{brandName}} Score Report to receiving institutions.</div>
    </div>
    <form
        name="
        score-report-form"
        [formGroup]="formGroup"
    >
        <div class="custom-control custom-checkbox">
            <input
                type="checkbox"
                class="custom-control-input"
                id="phone-number-check"
                name="phoneProvided"
                formControlName="phoneProvided"
            >
            <label
                class="custom-control-label"
                for="phone-number-check"
                style="font-weight: 500; font-size: 18px;"
            >Yes, send my test scores to my mobile phone.</label>
        </div>
        <br />
        <div *ngIf="formGroup.controls.phoneProvided.value">
            <ng-template #popContent1>
                <span style="font-weight: 500; font-size: 18px;">For example: 6045678989</span>
            </ng-template>
            <label for="input-last-name">Phone Number <span class="required fa fa-asterisk"></span> (Numbers only)
                <i
                    class="fa fa-question-circle-o"
                    [ngbPopover]="popContent1"
                    placement="top"
                ></i>
            </label>
            <br />
            <ngx-intl-tel-input
                [cssClass]="'custom form-control'"
                [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectedCountryISO]="CountryISO.Canada"
                [preferredCountries]="preferredCountries"
                [enablePlaceholder]="true"
                [maxLength]="15"
                [separateDialCode]="false"
                [numberFormat]="phoneNumberFormat"
                formControlName="phoneNumber"
                name="phoneNumber"
            >
            </ngx-intl-tel-input>
            <br />
            <small
                class="error"
                *ngIf="formGroup.controls.phoneProvided.value  && (!formGroup.controls.phoneNumber.value || 
                       formGroup.controls.phoneNumber.errors?.required && (formGroup.controls.phoneNumber.value.e164Number.length !== 12 || formGroup.controls.phoneNumber.value.e164Number.indexOf('753') !== 2))"
            >Please enter a valid phone number.</small>
        </div>
    </form>
    <div
        class="control-button-row"
        style="margin-top: 2em; margin-bottom: 2em;"
    >
        <button
            name="confirmationYesBtn"
            type="button"
            class="btn btn-primary"
            (click)="clickNextPage()"
        >Continue</button>
    </div>
</div>
